var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Assembly view mode ("visual" blocks vs "classic" list) for Items in Assembly.
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';
var STORAGE_KEY = 'packingAssemblyViewMode';
var readStoredMode = function () {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'classic' ? 'classic' : 'visual';
    }
    catch (_a) {
        return 'visual';
    }
};
var currentMode = readStoredMode();
var listeners = new Set();
export var setAssemblyViewMode = function (mode) {
    currentMode = mode;
    try {
        localStorage.setItem(STORAGE_KEY, mode);
    }
    catch (_a) {
        // noop
    }
    listeners.forEach(function (listener) { return listener(); });
};
export var useAssemblyViewMode = function () {
    var _a = useState(currentMode), mode = _a[0], setMode = _a[1];
    useEffect(function () {
        var listener = function () { return setMode(currentMode); };
        listeners.add(listener);
        listener(); // catch a change between first render and subscription
        return function () {
            listeners.delete(listener);
        };
    }, []);
    return mode;
};
export var AssemblyViewToggleButton = function () {
    var t = useTranslation().t;
    var mode = useAssemblyViewMode();
    var isVisual = mode === 'visual';
    return (_jsx(Tooltip, __assign({ title: (isVisual
            ? t('Assembly view: visual — switch to classic')
            : t('Assembly view: classic — switch to visual')) }, { children: _jsx("button", __assign({ type: 'button', onClick: function () { return setAssemblyViewMode(isVisual ? 'classic' : 'visual'); }, className: 'flex items-center justify-center rounded-lg border border-gray-200 bg-white p-2 text-gray-500 leading-none transition-colors hover:bg-gray-50 sm:px-4' }, { children: isVisual ? (_jsx(AppstoreOutlined, { style: { fontSize: 14 } }, void 0)) : (_jsx(UnorderedListOutlined, { style: { fontSize: 14 } }, void 0)) }), void 0) }), void 0));
};
